function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  role: "img"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 32,
  height: 32,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h32v32H0z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.1 22.667h2v-8h-2zM16 12.2q.466 0 .783-.307.317-.306.317-.76 0-.48-.316-.807A1.05 1.05 0 0 0 16 10a1.05 1.05 0 0 0-.784.326 1.11 1.11 0 0 0-.316.807q0 .454.316.76.316.307.783.307m.009 17.133q-2.759 0-5.183-1.05a13.6 13.6 0 0 1-4.243-2.866 13.5 13.5 0 0 1-2.867-4.245q-1.05-2.428-1.05-5.189 0-2.76 1.05-5.188a13.3 13.3 0 0 1 2.867-4.228 13.7 13.7 0 0 1 4.245-2.85q2.428-1.05 5.189-1.05 2.76 0 5.188 1.05t4.228 2.85 2.85 4.233 1.05 5.191-1.05 5.183a13.6 13.6 0 0 1-2.85 4.237 13.5 13.5 0 0 1-4.233 2.866q-2.433 1.056-5.191 1.056"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-info-circle-2.svg";
export { SvgComponent as ReactComponent };